import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ai-select" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "controls" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "options",
      disabled: $props.disabled
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, idx) => {
        return (_openBlock(), _createBlock(_component_Button, {
          key: idx,
          class: _normalizeClass(["ai-option regular", {active: $data.selected === idx}]),
          onClick: $event => ($options.onSelect(idx))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              innerHTML: option.title
            }, null, 8 /* PROPS */, _hoisted_3)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: _normalizeClass(["confirm", {inactive: $options.skipped}]),
        primary: !$options.skipped,
        disabled: $options.confirm_disabled,
        onClick: $options.onAccept
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Reply ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["primary", "disabled", "class", "onClick"]),
      ($props.skip)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "ai-option secondary",
            disabled: $props.disabled,
            onClick: $options.onSkip
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.skip.title || 'Skip'), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onClick"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}